import React, { Fragment } from 'react';
import {
  ComponentVerticalSpacing, ComponentWrapper, CardSlider, BlogPost
} from 'day8-react/build/new-components';
import PropTypes from 'prop-types';

const DestinationBlogPost = ({ title, destinationBlogs }) => {
  return (
    <Fragment>
      {posts && posts.length > 0 && (
      <ComponentVerticalSpacing>
        <ComponentWrapper>
          {title && <h2 className="d8-u-ls-sm text-center">{title}</h2>}
          <CardSlider>
            {destinationBlogs.map(post => (
              <BlogPost key={post.id} post={post} />
            ))}
          </CardSlider>
        </ComponentWrapper>
      </ComponentVerticalSpacing>
      )}
    </Fragment>
  );
};

DestinationBlogPost.propTypes = {
  title: PropTypes.string
};

export default DestinationBlogPost;
